module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.5.12-114.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/v2.5.12.md
// module id = 531
// module chunks = 283